import { Navigate, useLocation } from 'react-router-dom';
import { legacyOrgAdminRedirectTarget, moduleAdminPath } from '@/config/moduleDefaults';
import { useActiveModule } from '@/hooks/useActiveModule';
import { useAppSelector } from '@/hooks/useAppSelector';
import type { ErpModule } from '@/api/platform.api';

export function LegacyOrgAdminRedirect({ fallbackModule = 'POS' }: { fallbackModule?: ErpModule }) {
  const location = useLocation();
  const activeModule = useActiveModule();
  const entryModule = useAppSelector((s) => s.auth.entryModule);
  const module = activeModule ?? entryModule ?? fallbackModule;
  const target =
    legacyOrgAdminRedirectTarget(location.pathname, module) ??
    moduleAdminPath(module, 'administration');
  return <Navigate to={`${target}${location.search}`} replace />;
}
